import { Liquid } from 'liquidjs';

import { SiteTemplateVersion } from '@/types/SiteTemplate';

export const initLiquidEngine = (siteTemplateVersion: SiteTemplateVersion) => {
  const engine = new Liquid({
    relativeReference: false,
    fs: {
      readFileSync: (identifier) => {
        const snippet = findSnippet(siteTemplateVersion, { identifier });
        return snippet?.liquidMarkup || '';
      },
      readFile: (identifier) => {
        const snippet = findSnippet(siteTemplateVersion, { identifier });
        return Promise.resolve(snippet?.liquidMarkup || '');
      },
      existsSync: () => true,
      exists: async () => true,
      resolve: (root, file) => {
        return file;
      },
    },
  });
  engine.registerFilter('asset_url', (fileName) => {
    const siteTemplateAsset = findAsset(siteTemplateVersion, { fileName });
    return siteTemplateAsset?.url;
  });

  engine.registerFilter(
    'videoproxy_play_url',
    (identifier) =>
      `${process.env.NEXT_PUBLIC_VIDEOPROXY_PUBLIC_API_URL}/play/${identifier}`
  );

  engine.registerFilter(
    'videoproxy_thumbnail_url',
    (identifier) =>
      `${process.env.NEXT_PUBLIC_VIDEOPROXY_PUBLIC_API_URL}/videos/${identifier}/thumbnail`
  );

  return engine;
};

const findAsset = (
  siteTemplateVersion: SiteTemplateVersion,
  { fileName }: { fileName: string }
) => {
  const siteTemplateAssets = siteTemplateVersion.templateAssets.nodes;
  return siteTemplateAssets?.find((s: any) => s.fileName === fileName);
};

const findSnippet = (
  siteTemplateVersion: SiteTemplateVersion,
  { identifier }: { identifier: string }
) => {
  const siteTemplateSnippets = siteTemplateVersion.templateSnippets.nodes;
  return siteTemplateSnippets?.find((s) => s.identifier === identifier);
};
